import { Circle, ClipboardList, Clock3, Grid2x2, Mic, Pencil, Tag, Type } from "lucide-react"
import type React from "react"

const baseClassName = "size-3.5 shrink-0 text-muted-foreground"

const commonIconMap: Record<string, React.ReactElement> = {
  score: <ClipboardList className={baseClassName} />,
  piqual: <ClipboardList className={baseClassName} />,
  pirads: <ClipboardList className={baseClassName} />,
  vector: <Pencil className={baseClassName} />,
  image_label: <Tag className={baseClassName} />,
  text: <Type className={baseClassName} />,
  annotation_time: <Clock3 className={baseClassName} />,
  label_raster: <Grid2x2 className={baseClassName} />,
  voice_note: <Mic className={baseClassName} />
}

/**
 * Returns a module type icon while allowing workspace-specific overrides.
 */
export function resolveModuleTypeIcon(
  type: string,
  overrides: Record<string, React.ReactElement> = {}
): React.ReactElement {
  return overrides[type] ?? commonIconMap[type] ?? <Circle className={baseClassName} />
}
